import React, { useEffect, useState } from 'react';
import { Upload, Button, Typography, Card, Row, Col, Divider, notification, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import Pesquisar from '../../VendasView/Pesquisar';
import PesquisarProdutosXml from './PesquisarProdutosXml';
import ModalItemSelecionado from '../../VendasView/ModalItemSelecionado';
import ModalItemSelecionadoEntrada from './ModalItemSelecionadoEntrada';
import axios from 'axios';

const { Title, Text } = Typography;

const EntradaManual = () => {
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [loja, setLoja] = useState({});
  const [total, setTotal] = useState(0);
  const [produtos, setProdutos] = useState([]);
  const [qtdTotal, setQtdTotal] = useState(0);
  const [cabecalho, setCabecalho] = useState(null);
  const [destinatario, setDestinatario] = useState(null);
  const [isPesquisar, setIsPesquisar] = useState(false);
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isModalVisibleItem, setModalVisibleItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [executarBusca, setExecutarBusca] = useState(false);
  const [desabilitarFinalizar, setDesabilitarFinalizar] = useState(false);

  const trataProdutos = produto => {
    setProdutos([produto, ...produtos]);
    calculadorTotais();
  };
  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      axios
        .get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(restaurante => {
          setLoja(restaurante.data);

        });
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (loja) {
      montarCabecalho();
      calculadorTotais();
    }
  }, [loja, produtos]);

  async function calculadorTotais() {
    let total = produtos.reduce((soma, produto) => {
      return soma + parseFloat(produto.custo * produto.quantidade || 0);
    }, 0);
    let qtdTotalAux = produtos.reduce((soma, produto) => {
      return soma + parseFloat(produto.quantidade || 0);
    }, 0);
    setTotal(total);
    setQtdTotal(qtdTotalAux);
  }

  useEffect(() => {
    async function fetchData() {
      console.log('dentro do fetchData');
      try {
        var cont = 0;
        while (cont < 6) {
          await new Promise((resolve) => setTimeout(resolve, 10000));
          const options = {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + accessToken,
            },
          };

          console.log('getTransacaoById');
          const { data: result } = await axios.get(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/transacao/${transactionId}`, options);


          console.log(result);
          //setTransactionId(result);

          if (result.status === '2') {
            notification.info({
              message: 'Informação',
              description: 'As alterações estão sendo processadas.',
            });
          }
          if (result.status === '3') {
            setExecutarBusca(false);
            //handleRefreshClick();
            notification.success({
              message: 'Sucesso',
              description: 'As alterações foram concluidas.',
            });

            cont = 7;
            break;
          }
          cont++;
        }

        if (cont === 6) {
          window.alert('O Processamento ainda esta ocorrendo!');
        }
      } catch (error) {
        console.error(error);
      }
    }

    if (loja.id && transactionId && executarBusca) {
      fetchData();
    }
  }, [loja.id, transactionId, executarBusca]);


  const xmlToJson = (xml) => {
    const obj = {};
    if (xml.nodeType === 1 && xml.attributes.length > 0) {
      obj['@attributes'] = {};
      for (let j = 0; j < xml.attributes.length; j++) {
        const attribute = xml.attributes.item(j);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    } else if (xml.nodeType === 3) {
      return xml.nodeValue.trim();
    }

    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const nodeName = item.nodeName;
        const nodeValue = xmlToJson(item);
        if (typeof nodeValue === 'string' && nodeValue === '') continue;

        if (obj[nodeName] === undefined) {
          obj[nodeName] = nodeValue;
        } else {
          if (!Array.isArray(obj[nodeName])) {
            obj[nodeName] = [obj[nodeName]];
          }
          obj[nodeName].push(nodeValue);
        }
      }
    }
    return obj;
  };

  const montarCabecalho = () => {
    try {
      setCabecalho({
        data: formatDate(new Date()),
        cnpj: '',
        ie: '',
        nomeEmitente: '',
        numero: '',
        chave: '',
        qtdItens: produtos.length,
      });

    } catch (error) {
      console.error('Erro ao processar XML:', error);
      setProdutos([]);
      setCabecalho(null);
      setDestinatario(null);
    }
  };


  const getText = (val) => {
    if (typeof val === 'object' && val !== null && '#text' in val) return val['#text'];
    return val || '';
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return isNaN(date) ? dateStr : date.toLocaleDateString('pt-BR');
  };

  const formatCurrency = (value) => {
    const num = Number(value);
    return isNaN(num) ? value : num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const formatCNPJ = (cnpj) => {
    if (!cnpj) return '';
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  const formatIE = (ie) => {
    if (!ie) return '';
    return ie.replace(/(\d{3})(\d{3})(\d{3})(\d{3})?/, (match, p1, p2, p3, p4) =>
      p4 ? `${p1}.${p2}.${p3}.${p4}` : `${p1}.${p2}.${p3}`
    );
  };



  const handlePesquisarClick = () => {
    setIsPesquisar(true); // Mostrar a tela de pesquisa
  };

  const handleVoltarClick = () => {
    setIsPesquisar(false); // Voltar para a tela de vendas
  };

  const openModalItem = produto => {
    setSelectedProduto(produto);
    setModalVisibleItem(!isModalVisibleItem);
  };


  const [recalcular, setRecalcular] = useState(false);


  const salvarEntrada = async () => {
    setLoading(true);
    setDesabilitarFinalizar(true);
    let valorComDesconto = 0;
    const novoObjeto = produtos.map(p => ({
      id: p.id,
      movimentacao: p.quantidade,
      valor: (p.custo - (p.desconto ? parseFloat(p.desconto) / p.quantidade : 0))
    }));

    console.log("Novo objeto:", novoObjeto);
    console.log("produtos", produtos);
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
    let total = produtos.reduce((soma, produto) => {
      return soma + parseFloat(produto.custo * produto.quantidade || 0);
    }, 0);

    let desconto = produtos.reduce((desconto, produto) => {
      return desconto + parseFloat(produto.desconto || 0);
    }, 0);

    total = total - desconto;

    if (novoObjeto.length > 0) {
      try {
        const response = await axios.get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/geraTransacao/${loja.id}`,
          options
        );

        console.log('Transação criada:', response.data);
        // continue com a lógica usando response.data (o id da transação)

        let cont = 0;
        let transactionInfo;
        do {
          axios.put(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/editarLista/${loja.id}/${response.data}/compra/${total}/${idUser}`, novoObjeto, options);

          if ((loja.id, response.data)) {
            transactionInfo = await axios.get(`https://techspdv-api-d3e739785e34.herokuapp.com/v1/movimentacaoEstoque/transacao/${response.data}`, options);



            if (transactionInfo.data.status !== '1') {
              console.log(transactionInfo.data);
              setTransactionId(response.data);
              setExecutarBusca(true);
              setProdutos([]);
              notification.info({
                message: 'Informação',
                description: 'As alterações estão sendo processadas.',
              });

            } else {
              await new Promise((resolve) => setTimeout(resolve, 10000));
              cont++;
              console.log(cont + 'tentativa');
              if (cont === 6) {
                setLoading(false);
                notification.error({
                  message: 'Erro',
                  description:
                    'Não foi possível o envio das alterações, tente novamente mais tarde.',
                });
              }
            }
          }
        } while (transactionInfo.data.status === '1' && cont < 6);
      } catch (error) {
        if (error.response && error.response.status === 409) {
          notification.info({
            message: 'Informação',
            description: 'Já existe uma transação ativa para essa loja nos últimos 30 segundos.',
          });
        } else {
          console.error('Erro ao criar transação:', error);
          // outros tipos de erro
        }
      }
    } else {
      setLoading(false);
      setDesabilitarFinalizar(false);
    }
    setLoading(false);
    setDesabilitarFinalizar(false);
  };


  return (
    <div style={{ padding: 16, boxSizing: 'border-box', maxWidth: '100%', overflowX: 'hidden', height: '80vh' }}>
      <Title level={4} style={{ marginBottom: 8 }}>Entrada Manual</Title>
      {isPesquisar ? (
        <PesquisarProdutosXml
          onItemPress={trataProdutos}
          closeModal={handleVoltarClick}
          validarEstoque={false}
        ></PesquisarProdutosXml>
      ) : isModalVisibleItem ? (


        <ModalItemSelecionadoEntrada
          isVisible={isModalVisibleItem}
          onClose={() => setModalVisibleItem(false)}
          onSave={updatedProduto => {
            console.log(updatedProduto);
            produtos[updatedProduto.index] = updatedProduto;
            //produto = updatedProduto;
            setRecalcular(!recalcular);
            calculadorTotais();
          }}
          onDelete={item => {
            produtos.splice(item.index, 1);
            setRecalcular(!recalcular);
            calculadorTotais();
          }}
          produto={selectedProduto}
        />
      ) :
        (<><div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <button
            onClick={() => handlePesquisarClick()}
            style={{
              flex: 1,
              marginRight: '10px',
              backgroundColor: '#000',
              color: '#fff',
              padding: '15px',
              borderRadius: '5px',
              border: 'none',
              fontSize: '16px',
            }}
          >
            <span style={{ display: 'block', fontSize: '24px' }}>🔍</span>
            Pesquisar
          </button>
          <button
            disabled={desabilitarFinalizar}
            style={{
              flex: 1,
              backgroundColor: '#90ee90',
              color: '#000',
              padding: '15px',
              borderRadius: '5px',
              border: 'none',
              fontSize: '16px',
            }}
            onClick={() => {
              !produtos.length > 0 ? window.alert('Adicione produtos a entrada!') :
                salvarEntrada();
            }}

          >
            <span style={{ display: 'block', fontSize: '24px' }}>✔️</span>
            Finalizar Entrada
          </button>

        </div>
          {loading ?
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40, width: '100%' }}>
              <Spin
                spinning={loading}
                tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
                size="large"
              />
            </div> : ''
          }
          {!loading && cabecalho && (
            <div style={{ marginTop: 16, fontSize: 12 }}>
              <Row gutter={[12, 4]}>
                <Col span={24}><Text><strong>Emitente:</strong> {cabecalho.nomeEmitente}</Text></Col>
                <Col span={8}><Text><strong>Data NF:</strong> {cabecalho.data}</Text></Col>
                <Col span={8}><Text><strong>CNPJ:</strong> {formatCNPJ(cabecalho.cnpj)}</Text></Col>
                <Col span={8}><Text><strong>IE:</strong> {formatIE(cabecalho.ie)}</Text></Col>
                <Col span={8}><Text><strong>Qtd. Itens:</strong> {qtdTotal}</Text></Col>
                <Col span={8}><Text><strong>Número NF:</strong> {cabecalho.numero}</Text></Col>
                <Col span={8}><Text><strong>Valor Total:</strong> {formatCurrency(parseFloat(total))}</Text></Col>
                <Col span={24}><Text><strong>Chave NF-e:</strong> {cabecalho.chave}</Text></Col>
              </Row>
              <Divider style={{ marginTop: 12, marginBottom: 12 }} />
            </div>
          )}

          {!loading && destinatario && (
            <Card size="small" title="Destinatário" style={{ marginBottom: 12 }}>
              <p style={{ fontSize: 12, marginBottom: 2 }}><strong>Nome:</strong> {destinatario.nome}</p>
              <p style={{ fontSize: 12, marginBottom: 2 }}><strong>CNPJ:</strong> {formatCNPJ(destinatario.cnpj)}</p>
            </Card>
          )}

          {!loading && produtos.length > 0 && (
            <div
              style={{
                height: '80vh',
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingRight: 8,
              }}
            >
              <Row gutter={[8, 8]}>
                {produtos.map((produto, index) => {
                  produto.index = index;
                  console.log(produto);

                  return (
                    <Col span={24} key={index}>
                      <Card
                        title={
                          <Row justify="space-between" align="middle">
                            <Col>
                              <span style={{ fontSize: 14, fontWeight: 'bold' }}>
                                {produto.cProd} - {produto.nome}
                              </span>
                            </Col>
                            <Col>
                              <button
                                style={{
                                  fontSize: 15,
                                  padding: '4px 10px',
                                  cursor: 'pointer',
                                  borderRadius: 4,
                                  border: 'none',
                                  backgroundColor: 'black',
                                  color: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 4
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!produto.travado) openModalItem(produto);
                                }}
                              >
                                ✎
                              </button>

                            </Col>
                          </Row>
                        }
                        bordered={true}
                        style={{ width: '100%' }}
                        bodyStyle={{ padding: 8 }}
                        size="small"
                      >
                        <Row gutter={[12, 4]} style={{ fontSize: 12 }}>
                          <Col><strong>QTD:</strong> {produto.quantidade}</Col>
                          <Col><strong>V.UNITÁRIO: </strong>{formatCurrency(parseFloat(produto.custo)) + ' - ' + (formatCurrency(parseFloat(produto.valorDesconto) / produto.quantidade))} = {formatCurrency(parseFloat(produto.custo) - (parseFloat(produto.valorDesconto) / produto.quantidade))}</Col>
                        </Row>
                        <Row gutter={[12, 4]} style={{ fontSize: 12, marginBottom: 4 }}>
                          <Col><strong>EAN:</strong> {produto.ean}</Col>
                          <Col><strong>NCM:</strong> {produto.ncm}</Col>
                          <Col><strong>{produto.csosn ? 'CSOSN' : 'CST'}:</strong> {produto.origem}{produto.csosn || produto.cst}</Col>
                          <Col><strong>CFOP:</strong> {produto.cfop}</Col>
                          <Col><strong>UN:</strong> {produto.unidade}</Col>
                          <Col>
                            <strong>
                              V.TOTAL: <u>{formatCurrency((produto.custo * produto.quantidade) - parseFloat(produto.valorDesconto))}</u>
                            </strong>
                          </Col>

                          <Col><strong>BC ICMS:</strong> {produto.vBC ? formatCurrency(produto.vBC) : formatCurrency(0)}</Col>
                          <Col><strong>V.ICMS:</strong> {produto.vICMS ? formatCurrency(produto.vICMS) : formatCurrency(0)}</Col>
                          <Col><strong>V.IPI:</strong> {produto.vIPI ? formatCurrency(produto.vIPI) : formatCurrency(0)}</Col>
                          <Col><strong>ALIQ.ICMS:</strong> {produto.pICMS ? formatCurrency(produto.pICMS) : formatCurrency(0)}</Col>
                          <Col><strong>ALIQ.IPI:</strong> {produto.pIPI ? formatCurrency(produto.pIPI) : formatCurrency(0)}</Col>
                        </Row>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}
        </>
        )
      }

    </div>
  );
};

export default EntradaManual;
